const DASH = '-';

const mapItem = ({
	id,
	sourceEngagement = DASH,
	activityType = DASH,
	objectImpacted = DASH,
	relatedObjectImpacted = DASH,
	relatedSecondaryObjectImpacted = DASH,
	activityDate
}) => ({
	id,
	sourceEngagement: !!sourceEngagement ? sourceEngagement : DASH,
	activityType: !!activityType ? activityType : DASH,
	objectImpacted: !!objectImpacted ? objectImpacted : DASH,
	relatedObjectImpacted: !!relatedObjectImpacted ? relatedObjectImpacted : DASH,
	relatedSecondaryObjectImpacted: !!relatedSecondaryObjectImpacted ? relatedSecondaryObjectImpacted : DASH,
	activityDate
});

export default (data) => data.map(mapItem);
